module.exports = __webpack_public_path__ + "images/13_61e6be61.jpg";